import { render, staticRenderFns } from "./ExchangeCode.vue?vue&type=template&id=38e3f132&scoped=true"
import script from "./ExchangeCode.vue?vue&type=script&lang=js"
export * from "./ExchangeCode.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCode.vue?vue&type=style&index=0&id=38e3f132&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3f132",
  null
  
)

export default component.exports